import global from './global.js';

function index() {
  global();
}

export default index;
